import { Link } from 'react-router-dom'
import { dayEnumList } from '../assets/data'

export default function ClassCard({ courses }) {
  const courseTimes = () => {
    const result = courses.courseTimeTable.reduce((acc, curr) => {
      const { dayOfWeek } = curr
      if (acc[dayOfWeek]) acc[dayOfWeek].push(curr)
      else acc[dayOfWeek] = [curr]
      return acc
    }, [])
    const times = []
    Object.entries(result).forEach(([key, value]) => {
      const periods = value.map((item) => item.coursePeriod).join(',')
      times.push(`${dayEnumList[key]} ${periods}교시`)
    })
    return times
  }
  return (
    <Link
      to={'/class/detail'}
      state={{ data: courses }}
      className='border_default flex max-h-[250px] min-w-[230px] max-w-[370px] cursor-pointer flex-col rounded-16'
    >
      <div
        className='relative h-[100px] rounded-t-16'
        style={{ backgroundColor: courses.image.backgroundColor }}
      >
        <img
          className='absolute right-[12px] top-0 h-full w-[154px] mix-blend-overlay'
          src={courses.image.imageUrl}
          alt=''
        />
      </div>
      <div className='flex grow flex-col justify-between px-20 py-16'>
        <div className='flex flex-col items-start gap-4'>
          <p className='text-body1-semibold text-label-default'>{courses.subject.name}</p>
          <p className='line-clamp-1 text-body3-medium text-label-sub'>{courses.className}</p>
          {/* {courses.courseTimeTable.map((timeItem, timeIndex) => ( */}
          <div className='line-clamp-2'>
            <p className='text-body3-regular text-label-info'>{courseTimes().join('/')}</p>
            <p className='text-body3-regular text-label-info'></p>
          </div>
          {/* ))} */}
        </div>
      </div>
    </Link>
  )
}
